import React, { useState, useEffect } from "react";
import "./full-menu.css";
import SelectedMenuItem from "../SelectedMenuItem/SelectedMenuItem";

// Sample Menu Categories
const allCategories = [
  "All",
  "iftar_package",
  "late_night",
  "dinner",
  "lunch",
  "breakfast",
  "snacks",
  "drinks",
  "pre_order",
  "catering",
];

const FullMenu = ({ selectedCategory, items }) => {
  const [activeCategory, setActiveCategory] = useState(selectedCategory);
  const [selectedItem, setSelectedItem] = useState(null);

  // Update the active category when the selectedCategory prop changes
  useEffect(() => {
    setActiveCategory(selectedCategory);
  }, [selectedCategory]);

  // Filter menu items based on the active category only
  const filteredMenu = items.filter((item) => {
    const matchesCategory =
      activeCategory === "All" || item.category.includes(activeCategory);

    return matchesCategory && item.availability;
  });

  return (
    <section className="full-menu" id="full-menu">
      <div className="full-menu-container">
        <h2 className="full-menu-title">Our Menu</h2>

        {/* Category Filters */}
        <div className="menu-filters">
          {allCategories.map((category) => (
            <button
              key={category}
              className={`filter-btn ${
                activeCategory === category ? "active" : ""
              }`}
              onClick={() => setActiveCategory(category)}
            >
              {category.replace(/_/g, "-").toUpperCase()}
            </button>
          ))}
        </div>

        {/* Menu Items */}
        <div className="full-menu-content">
          {filteredMenu.map((item) => (
            <div key={item._id} className="menu-item">
              <img
                src={item.imageUrl[0]}
                alt={item.title}
                className="menu-item-img"
              />
              <h3 className="menu-item-title">{item.title}</h3>
              <p className="menu-item-description">{item.desc}</p>
              <p className=" font-bold pt-4">
                {item.category[0].replace(/_/g, "-").toUpperCase()}
              </p>
              <div className="menu-item-price-order">
                <span className="menu-item-price">৳{item.price}</span>
                <button
                  className="menu-item-order-btn btn btn-primary"
                  onClick={() => setSelectedItem(item)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Selected Item Modal */}
      {selectedItem && (
        <SelectedMenuItem
          menuItem={selectedItem}
          closeModal={() => setSelectedItem(null)}
        />
      )}
    </section>
  );
};

export default FullMenu;
